
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopify-integration",
      function () {
        return require("private-next-pages/shopify-integration.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopify-integration"])
      });
    }
  